import { render, staticRenderFns } from "./create-layout.vue?vue&type=template&id=f42120ba&scoped=true"
import script from "./create-layout.vue?vue&type=script&lang=js"
export * from "./create-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42120ba",
  null
  
)

export default component.exports